// axios
import axios from 'axios'
import cachios from 'cachios'

console.log(process.env)

const defaultAxios = axios.create({
//  baseURL: process.env.NODE_ENV === 'development' ? process.env.VUE_APP_ROOT_API_DEV : process.env.VUE_APP_ROOT_API_PROD
   baseURL: process.env.VUE_APP_ROOT_API_PROD,
})

const cachedAxios = cachios.create(defaultAxios)

export { defaultAxios, cachedAxios }
